<template>
  <path
    d="M10.8536 11.5214C10.6583 11.7167 10.3417 11.7167 10.1464 11.5214L7.60355 8.97855C7.28857 8.66357 7.51165 8.125 7.95711 8.125H13.0429C13.4883 8.125 13.7114 8.66357 13.3964 8.97855L10.8536 11.5214Z"
    fill="currentColor" />
</template>
